module.exports = __webpack_public_path__ + "img/bolt.14dc62d1.svg";